import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type searchTextState = {
    searchText : string,
    triggerSearchProductListRefresh : string
}

const initialState : searchTextState = {
    searchText: "",
    triggerSearchProductListRefresh: ""
}

export const searchTextSlice = createSlice({
    name: 'searchText',
    initialState: initialState,
    reducers: {
        setSearchText: (state, action : PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setTriggerSearchProductListRefresh: (state, action : PayloadAction<string>) => {
            state.triggerSearchProductListRefresh = action.payload;
        },   
    }
});

export const { setSearchText, setTriggerSearchProductListRefresh } = searchTextSlice.actions;

export default searchTextSlice.reducer;